import { defaultQuotaLicense, License, licenseSchema } from "./License";
import { useTranslation } from "react-i18next";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { makeRequired } from "../../../shared/components/forms/formUtils";
import { Grid } from "@mui/material";
import { MuiRhfTextField } from "../../../shared/components/forms/MuiRhfTextField";
import { Application } from "../Application";
import { AddButton } from "../../../shared/components/buttons/AddButton";
import { MuiRhfNumberField } from "../../../shared/components/forms/MuiRhfNumberField";

export function QuotaLicensesForm(props: {
  application: Application,
  license: License,
  readOnly: boolean,
}) {
  const { t } = useTranslation();
  const { control } = useFormContext<License>();
  const { fields, append } = useFieldArray<License>({
    control: control,
    name: "quotaLicenses"
  });

  return (
    <>
      <Grid item={true} xs={12} md={7} lg={8}>
        {!props.readOnly &&
          <AddButton onClick={() => append(defaultQuotaLicense(t))} />
        }
      </Grid>
      {fields.map((item, index) => (
        <Grid item={true} xs={12} md={7} lg={8} sx={{ marginTop: 2 }} key={item.id}>
          <QuotaLicenseForm index={index} readOnly={props.readOnly} />
        </Grid>
      ))}
    </>
  );
}

export function QuotaLicenseForm(props: {
  index: number,
  readOnly: boolean,
}) {
  const formReadonly = props.readOnly;
  const { t } = useTranslation();

  const stdFieldProps = {
    variant: "outlined" as "outlined",
    disabled: formReadonly,
    InputLabelProps: {
      shrink: true
    }
  }
  const required = makeRequired(licenseSchema(t));
  return (
    <Grid item={true} xs={12} md={7} lg={8}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12} lg={6}>
          <MuiRhfTextField name={`quotaLicenses.${props.index}.name`}
                           label={t('License.quotaLicense.name')}
                           fullWidth={true}
                           required={required.quotaLicenses.name}
                           {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={10} lg={5}>
          <MuiRhfNumberField name={`quotaLicenses.${props.index}.quota`}
                             label={t('License.quotaLicense.quota')}
                             fullWidth={true}
                             {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={10} lg={5}>
          <MuiRhfNumberField name={`quotaLicenses.${props.index}.usage`}
                             label={t('License.quotaLicense.usage')}
                             fullWidth={true}
                             {...stdFieldProps}
                             disabled={true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
